export default __webpack_public_path__ + "static/media/Bangles.577d9b5d.jpg";